var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Flex from "../../../components/templates/flex";
var Anchor = styled(Flex).attrs({ as: "a" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  & :hover {\n    text-decoration: none;\n  }\n"], ["\n  text-decoration: none;\n  & :hover {\n    text-decoration: none;\n  }\n"])));
export default Anchor;
var templateObject_1;
